import { DatalayerHelper } from './ib-datalayer-helper';
import isEqual from 'lodash-es/isEqual.js';
import omit from 'lodash-es/omit.js';
import * as ancillariesInfo   from '../core/models/ancillaries-info';

@Service('ib-web-ancillaries-module',
    ['CommonsUtilService', 'DatalayerUtilsService', 'DatalayerHelper'],
    ['ib-commons-constants-module', 'ib-monetate-module'])
export class BaggageDatalayerUtils {
    seatSelectedId: string[] = [];
    seatSelectedType: string[] = [];
    segmentId: string;
    constructor (
        private CommonsUtilService: CommonsUtilService,
        private DatalayerUtilsService: DatalayerUtilsService,
        private DatalayerHelper: DatalayerHelper
    ) { }

    getBagaggeItemVariant (piece: ancillariesInfo.Piece) {
        return piece?.description.replace('Kg', 'kilos').replace('kg', 'kilos');
    }

    getBaggageQuantity (slice) {
        return slice?.passengers?.length;
    }

    getDataEcommerceForBaggage (ancillaryType: string, piece: any, slice) {
        const itemCategory2: string = this.DatalayerUtilsService.getItemCategory2(slice);
        const id = this.CommonsUtilService.getIdItem('all');
        const item: DigitalDataEcommerceModel.Item = {
            item_name: ancillaryType,
            item_id: id,
            price:  piece?.availablePriceRanges[0]?.amount,
            item_brand: this.DatalayerHelper.getBrandItem(slice?.id, slice?.id),
            item_category: this.DatalayerHelper.getItemCategory(),
            item_category2: itemCategory2,
            item_category3: this.DatalayerUtilsService.getItemCategory3(ancillaryType, itemCategory2, id),
            item_variant: this.getBagaggeItemVariant(piece),
            quantity: this.getBaggageQuantity(slice)
        };
        return item;
    }
    getBaggageItem = (trip, piece) => {
        const itemCategory2: string = trip.departure.code + '-' + trip.arrival.code;
        const id: string = this.CommonsUtilService.getIdItem('all');
        const item: DigitalDataEcommerceModel.Item = {
            item_name: 'baggage',
            item_id: id,
            price: this.DatalayerHelper.getBaggagePrice(piece),
            item_brand: this.DatalayerHelper.getBrandItem(trip?.departure?.code, trip?.id),
            item_category: this.DatalayerHelper.getItemCategory(),
            item_category2: itemCategory2,
            item_category3: this.DatalayerUtilsService.getItemCategory3('baggage', itemCategory2, id),
            item_variant: this.getBagaggeItemVariant(piece),
            quantity: Number(piece.quantySelected)
        };
        return item;
    };
    setBaggagesSelectItem = (trip: any, piece: any): DigitalDataEcommerceModel.Item => {
        return this.getBaggageItem(trip, piece);
    };

    setBaggagesEventCart = (model: any): any => {
        const digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        model?.passengers.forEach(passenger => {
            passenger?.trips.forEach(trip => {
                trip.pieces.forEach(piece => {
                    if (piece.quantySelected > 0) {
                        const item = this.getBaggageItem(trip, piece);
                        const indexAddToCart = digital_data_ecommerce.items.findIndex(itemAddToCart => isEqual(omit(item, ['quantity']), omit(itemAddToCart, ['quantity'])));
                        if (indexAddToCart < 0) {
                            digital_data_ecommerce.items.push(item);
                        } else {
                            digital_data_ecommerce.items[indexAddToCart].quantity = digital_data_ecommerce.items[indexAddToCart].quantity + item.quantity;
                        }
                    }
                });
            });
        });
        return digital_data_ecommerce;
    };

    setBaggagesRemoveFromCart = (trip: any, piece: any): DigitalDataEcommerceModel.Item => {
        return this.getBaggageItem(trip, piece);
    };
}